export default "__VITE_ASSET__BoCKec6c__"